<template>
	<div>
		<div
				class="card mb-4 documents-card"
				v-if="personalInfo.contract_documents"
		>
			<div class="card-body p-4 p-md-5">
				<h5 class="mb-4 color-yellow">Vzorová zmluvná dokumentácia</h5>
				<div class="mb-4">
					Po akceptácii Vašej registrácie
					{{ getCompanyText("companies_instrumental") }} Vám zašleme kompletnú
					zmluvnú dokumentáciu s Vašimi údajmi.
				</div>
				<div class="row">
					<div class="col-6 col-md-6" v-for="document in personalInfo.contract_documents_all" :key="document.id">
						<a @click="download(document.template_key)">
						<font-awesome-icon :icon="fileIcon" class="mr-2"/>
						{{ document.name }}
						</a>
					</div>
				</div>
			</div>
		</div>
		<div
				class="card mb-4 documents-card"
				v-if="personalInfo.contract_documents && personalInfo.intermediary_person"
		>
			<div class="card-body p-4 p-md-5">
				<h5 class="mb-4 color-yellow">Zmluvy so sprostredkovateľom</h5>
				<div class="row">
					<div class="col-12">
						<p>
							Nakoľko ste tiež klientom
							{{ personalInfo.intermediary_person.intermediary.name }}
							(finančného sprostredkovateľa) prečítajte si prosím aj vzorovú
							dokumentáciu medzi Vami a Vaším sprostredkovateľom:
						</p>
						<a @click="download('contractSFA')"
						>
							<font-awesome-icon :icon="fileIcon" class="mr-2"/>
							Zmluva medzi
							klientom a SFA</a
						><br/>
						<a @click="download('tariffSFA')"
						>
							<font-awesome-icon :icon="fileIcon" class="mr-2"/>
							Cenník SFA</a
						><br/>
					</div>
				</div>
			</div>
		</div>
		<div class="card mb-1">
			<div class="card-body p-3 p-md-5">
				<div class="col-12 mt-3">
					<b-form-checkbox v-model="checkboxes[0]" class="mb-5">
						<i v-html="getCompanyText('documentation.confirm')"/>
					</b-form-checkbox>
					<b-form-checkbox v-model="checkboxes[1]">
						<p><i>Týmto potvrdzujem a prehlasujem, že:</i></p>
						<ul class="pl-0 pl-md-3">
							<li class="pb-3">
								<i>
									Som pravdivo vyplnil/a všetky informácie v tomto Formulári k
									otvoreniu účtu.
								</i>
							</li>
							<li class="pb-3">
								<i v-html="getCompanyText('documentation.confirm2')"/>
							</li>
							<li>
								<i>
									Potvrdzujem, že som si stiahol/a a uložil/a návrhy zmluvných
									dokumentov, ktoré mi boli sprístupnené vo Formulári k
									otvoreniu účtu, na vhodný trvalý nosič tak, aby som ich mal/a
									v budúcnosti kedykoľvek k dispozícii.
								</i>
							</li>
						</ul>
					</b-form-checkbox>
				</div>
				<div class="px-3 mt-4 mb-1 color-yellow">
					<b>
						K uzatvoreniu zmluvy dôjde po tom ako bude
						{{ getCompanyText("companies_instrumental") }} akceptovaná Vaša
						online registrácia a bude Vám zaslaná zmluvná dokumentácia s Vašimi
						údajmi.
					</b>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Documentation",
	data() {
		return {
			checkboxes: [false, false],
			fileIcon: ["fa", "download"],
			path: ""
		};
	},
	mounted() {
		this.$store.dispatch("onboarding/getPersonalInfo");
		this.$store.dispatch("onboarding/getInvestmentQuestionnaire");
		this.path = process.env.VUE_APP_API_FILES_LINK;
	},
	computed: {
		personalInfo() {
			return this.$store.state.onboarding.personalInfo;
		},
    questionnaireTypeId() {
			return this.$store.state.onboarding.questionnaireTypeId;
		},
	},
	watch: {
		checkboxes() {
			if (this.checkboxes[0] && this.checkboxes[1]) {
				this.$emit("can-continue", {value: true});
			} else {
				this.$emit("can-continue", {value: false});
			}
		}
	},
	methods: {
		download(path) {
			this.$store.dispatch("onboarding/download", {path});
		}
	}
};
</script>

<style lang="scss">
.documents-card {
	a {
		cursor: pointer;
	}

	a:hover {
		text-decoration: underline !important;
		color: $yellow !important;
	}
}
</style>
